import React from "react";

import { Container, Tabs, Tab } from "react-bootstrap";
import { useSelector } from "react-redux";

import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import ComponentUpdateApparence from "../../components/admin/bandeau/ComponentUpdateApparence";
import bandeauInGovernanceDefault from "../../assets/images/bandeauInGovernanceDefault.jpg";
import bandeauInOperationDefault from "../../assets/images/bandeauInOperationDefault.jpg";
import bandeauEspacesDefault from "../../assets/images/bandeauEspacesDefault.jpg";
import bandeauInSocialDefault from "../../assets/images/bandeauInSocialDefault.jpg";
import bandeauInViewsDefault from "../../assets/images/bandeauInViewsDefault.jpg";

import bandeauInGovernanceChrono from "../../assets/images/bandeauInGovernanceChrono.jpg";
import bandeauInSocialChrono from "../../assets/images/bandeauInSocialChrono.jpg";
import bandeauInViewsChrono from "../../assets/images/bandeauInViewsChrono.jpg";
import bandeauEspacesChrono from "../../assets/images/bandeauEspacesChrono.jpg";

import illusRituels from "../../assets/images/illusRituels.jpg";
import illusRoles from "../../assets/images/illusRoles.jpg";
import illusPartiesPrenantes from "../../assets/images/illusPartiesPrenantes.jpg";
import illusTempsCollectifs from "../../assets/images/illusTempsCollectifs.jpg";
import { useTranslation } from "react-i18next";

const PageAdminStyle = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);

  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminStyle.titre1")} />
        <Tabs defaultActiveKey="governancePic" className="mb-3 tabsApparence">
          <Tab eventKey="governancePic" title={t("admin.PageAdminStyle.tabTitre1")}>
            <ComponentUpdateApparence
              champ="governancePic"
              defaultImg={
                ReduxInstance.governancePic
                  ? process.env.REACT_APP_URL_EXPRESS +
                    "images/instance/" +
                    ReduxInstance.governancePic
                  : bandeauInGovernanceDefault
              }
              personnalisation={ReduxInstance.governancePic ? true : false}
            />
          </Tab>
          <Tab eventKey="governancePicChrono" title={t("admin.PageAdminStyle.tabTitre1Chrono")}>
            <ComponentUpdateApparence
              champ="governancePicChrono"
              defaultImg={
                ReduxInstance.governancePicChrono
                  ? process.env.REACT_APP_URL_EXPRESS +
                    "images/instance/" +
                    ReduxInstance.governancePicChrono
                  : bandeauInGovernanceChrono
              }
              personnalisation={ReduxInstance.governancePicChrono ? true : false}
            />
          </Tab>

          <Tab eventKey="socialPic" title={t("admin.PageAdminStyle.tabTitre2")}>
            <ComponentUpdateApparence
              champ="socialPic"
              defaultImg={
                ReduxInstance.socialPic
                  ? process.env.REACT_APP_URL_EXPRESS + "images/instance/" + ReduxInstance.socialPic
                  : bandeauInSocialDefault
              }
              personnalisation={ReduxInstance.socialPic ? true : false}
            />
          </Tab>
          <Tab eventKey="socialPicChrono" title={t("admin.PageAdminStyle.tabTitre2Chrono")}>
            <ComponentUpdateApparence
              champ="socialPicChrono"
              defaultImg={
                ReduxInstance.socialPicChrono
                  ? process.env.REACT_APP_URL_EXPRESS +
                    "images/instance/" +
                    ReduxInstance.socialPicChrono
                  : bandeauInSocialChrono
              }
              personnalisation={ReduxInstance.socialPicChrono ? true : false}
            />
          </Tab>

          <Tab eventKey="operationPic" title={t("admin.PageAdminStyle.tabTitre3")}>
            <ComponentUpdateApparence
              champ="operationPic"
              defaultImg={
                ReduxInstance.operationPic
                  ? process.env.REACT_APP_URL_EXPRESS +
                    "images/instance/" +
                    ReduxInstance.operationPic
                  : bandeauInOperationDefault
              }
              personnalisation={ReduxInstance.operationPic ? true : false}
            />
          </Tab>

          <Tab eventKey="viewsPic" title={t("admin.PageAdminStyle.tabTitre4")}>
            <ComponentUpdateApparence
              champ="viewsPic"
              defaultImg={
                ReduxInstance.viewsPic
                  ? process.env.REACT_APP_URL_EXPRESS + "images/instance/" + ReduxInstance.viewsPic
                  : bandeauInViewsDefault
              }
              personnalisation={ReduxInstance.viewsPic ? true : false}
            />
          </Tab>
          <Tab eventKey="viewsPicChrono" title={t("admin.PageAdminStyle.tabTitre4Chrono")}>
            <ComponentUpdateApparence
              champ="viewsPicChrono"
              defaultImg={
                ReduxInstance.viewsPicChrono
                  ? process.env.REACT_APP_URL_EXPRESS +
                    "images/instance/" +
                    ReduxInstance.viewsPicChrono
                  : bandeauInViewsChrono
              }
              personnalisation={ReduxInstance.viewsPicChrono ? true : false}
            />
          </Tab>
          <Tab eventKey="espacePic" title={t("admin.PageAdminStyle.tabTitre9")}>
            <ComponentUpdateApparence
              champ="espacePic"
              defaultImg={
                ReduxInstance.espacePic
                  ? process.env.REACT_APP_URL_EXPRESS + "images/instance/" + ReduxInstance.espacePic
                  : bandeauEspacesDefault
              }
              personnalisation={ReduxInstance.espacePic ? true : false}
            />
          </Tab>
          <Tab eventKey="espacePicChrono" title={t("admin.PageAdminStyle.tabTitre10")}>
            <ComponentUpdateApparence
              champ="espacePicChrono"
              defaultImg={
                ReduxInstance.espacePicChrono
                  ? process.env.REACT_APP_URL_EXPRESS +
                    "images/instance/" +
                    ReduxInstance.espacePicChrono
                  : bandeauEspacesChrono
              }
              personnalisation={ReduxInstance.espacePicChrono ? true : false}
            />
          </Tab>
        </Tabs>

        <ComponentTitle title={t("admin.PageAdminStyle.titre2")} />
        <Tabs defaultActiveKey="rituelPic" className="mb-3 tabsApparence">
          <Tab eventKey="rituelPic" title={t("admin.PageAdminStyle.tabTitre5")}>
            <ComponentUpdateApparence
              champ="rituelPic"
              widthEditor={616}
              heightEditor={348}
              defaultImg={
                ReduxInstance.rituelPic
                  ? process.env.REACT_APP_URL_EXPRESS + "images/instance/" + ReduxInstance.rituelPic
                  : illusRituels
              }
              personnalisation={ReduxInstance.rituelPic ? true : false}
            />
          </Tab>
          <Tab eventKey="partieprenantePic" title={t("admin.PageAdminStyle.tabTitre6")}>
            <ComponentUpdateApparence
              champ="partieprenantePic"
              widthEditor={616}
              heightEditor={348}
              defaultImg={
                ReduxInstance.partieprenantePic
                  ? process.env.REACT_APP_URL_EXPRESS +
                    "images/instance/" +
                    ReduxInstance.partieprenantePic
                  : illusPartiesPrenantes
              }
              personnalisation={ReduxInstance.partieprenantePic ? true : false}
            />
          </Tab>
          <Tab eventKey="rolePic" title={t("admin.PageAdminStyle.tabTitre7")}>
            <ComponentUpdateApparence
              champ="rolePic"
              widthEditor={616}
              heightEditor={348}
              defaultImg={
                ReduxInstance.rolePic
                  ? process.env.REACT_APP_URL_EXPRESS + "images/instance/" + ReduxInstance.rolePic
                  : illusRoles
              }
              personnalisation={ReduxInstance.rolePic ? true : false}
            />
          </Tab>
          <Tab eventKey="tempscollectifPic" title={t("admin.PageAdminStyle.tabTitre8")}>
            <ComponentUpdateApparence
              champ="tempscollectifPic"
              widthEditor={616}
              heightEditor={348}
              defaultImg={
                ReduxInstance.tempscollectifPic
                  ? process.env.REACT_APP_URL_EXPRESS +
                    "images/instance/" +
                    ReduxInstance.tempscollectifPic
                  : illusTempsCollectifs
              }
              personnalisation={ReduxInstance.tempscollectifPic ? true : false}
            />
          </Tab>
        </Tabs>
      </Container>
    </>
  );
};

export default PageAdminStyle;
